import React from "react";
import { IntlProvider } from "react-intl";
import en from "../../lang/en.json";
import de from "../../lang/de.json";
import { put } from "../../util/fetch";

const Context = React.createContext({});

class IntlProviderWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.switchToEnglish = this.switchToEnglish.bind(this);
    this.switchToDeutsch = this.switchToDeutsch.bind(this);
    this.saveLanguagePreference = this.saveLanguagePreference.bind(this);

    // set language based on user
    const default_language = props.ownerlessShop
      ? props.company_default_language
      : props.user.shop_language;
    const messages = this.getMessages(default_language);

    this.state = {
      locale: default_language,
      messages: messages,
      switchToEnglish: this.switchToEnglish,
      switchToDeutsch: this.switchToDeutsch,
      user: props.ownerlessShop ? "" : props.user,
      isStaff: props.isStaff,
    };
  }

  getMessages(language) {
    switch (language) {
      case "en":
        return en;
      case "de":
        return de;
      default:
        return de;
    }
  }

  saveLanguagePreference(language) {
    const { user } = this.state;
    const url = `${location.origin}/api/user/update/${user.id}/language`;
    const body = {
      shop_language: language,
    };
    put(url, { body })
      .then(() => {
        user.shop_language = language;
      })
      .catch((error) => {
        console.error("Failed to save language preference:", error);
      });
  }

  switchToEnglish() {
    this.setState({ locale: "en", messages: en });
    if (!this.props.ownerlessShop) {
      this.saveLanguagePreference("en");
    }
  }

  switchToDeutsch() {
    this.setState({ locale: "de", messages: de });
    if (!this.props.ownerlessShop) {
      this.saveLanguagePreference("de");
    }
  }

  render() {
    const { children } = this.props;
    const { locale, messages } = this.state;
    return (
      <Context.Provider value={this.state}>
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages}
          defaultLocale="de"
        >
          {children}
        </IntlProvider>
      </Context.Provider>
    );
  }
}

export { IntlProviderWrapper, Context as IntlContext };
